/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
export type DashboardRendererQueryVariables = {};
export type DashboardRendererQueryResponse = {
    readonly user: {
        readonly dashboardToken: string | null;
    } | null;
};
export type DashboardRendererQuery = {
    readonly response: DashboardRendererQueryResponse;
    readonly variables: DashboardRendererQueryVariables;
};



/*
query DashboardRendererQuery {
  user {
    dashboardToken
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dashboardToken",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a77b294f92d7a81c3681e9b266e3c07",
    "id": null,
    "metadata": {},
    "name": "DashboardRendererQuery",
    "operationKind": "query",
    "text": "query DashboardRendererQuery {\n  user {\n    dashboardToken\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '5855a54eab2754431f1d9bafa4585d16';
export default node;
